import { useState, useEffect, useCallback } from "react";
import { playerService } from "../../services/api";
import toast from "react-hot-toast";

export const usePlayerHighlights = ({
  isOwnProfile,
  isAgentOwnThisPlayer,
  playerWyscoutId,
}) => {
  const [showHighlightsModal, setShowHighlightsModal] = useState(false);
  const [editableHighlights, setEditableHighlights] = useState([]);
  const [editableHighlightsLoading, setEditableHighlightsLoading] = useState(false);
  const [highlightsRefreshKey, setHighlightsRefreshKey] = useState(0);

  useEffect(() => {
    if (!isOwnProfile && !isAgentOwnThisPlayer) {
      return;
    }

    if (isAgentOwnThisPlayer && !playerWyscoutId) {
      return;
    }

    let isMounted = true;

    const fetchEditableHighlights = async () => {
      setEditableHighlightsLoading(true);

      try {
        const response = isOwnProfile
          ? await playerService.getPlayerHighlights()
          : await playerService.getAgentPlayerHighlights(playerWyscoutId);

        if (!isMounted) {
          return;
        }

        if (response.success) {
          const data = Array.isArray(response.data)
            ? response.data
            : response.data?.results || [];
          setEditableHighlights(data);
        } else {
          throw new Error(response.error || "Failed to load highlights");
        }
      } catch (err) {
        if (!isMounted) {
          return;
        }
        console.error("Error loading editable highlights:", err);
        setEditableHighlights([]);
        toast.error(err?.message || "Failed to load highlights");
      } finally {
        if (isMounted) {
          setEditableHighlightsLoading(false);
        }
      }
    };

    fetchEditableHighlights();

    return () => {
      isMounted = false;
    };
  }, [isOwnProfile, isAgentOwnThisPlayer, playerWyscoutId]);

  const handleHighlightsSave = useCallback((updatedHighlights) => {
    setEditableHighlights(updatedHighlights);
    setHighlightsRefreshKey((prev) => prev + 1);
  }, []);

  const openHighlightsModal = useCallback(() => {
    setShowHighlightsModal(true);
  }, []);

  const closeHighlightsModal = useCallback(() => {
    setShowHighlightsModal(false);
  }, []);

  return {
    showHighlightsModal,
    setShowHighlightsModal,
    openHighlightsModal,
    closeHighlightsModal,
    editableHighlights,
    editableHighlightsLoading,
    highlightsRefreshKey,
    handleHighlightsSave,
  };
};
